import type { ThirdPartySeat } from '@openx/types/options.ts';

export type ThirdPartySeatLookup = (seatId: string) => ThirdPartySeat | undefined;

export function createThirdPartySeatLookup(
  seats: ThirdPartySeat[] | undefined | null,
  demandPartnerId?: string | null
): ThirdPartySeatLookup {
  const seatsById = new Map<string, ThirdPartySeat | null>();

  for (const seat of Array.isArray(seats) ? seats : []) {
    if (demandPartnerId) {
      if (seat.demand_partner_id === demandPartnerId) {
        seatsById.set(seat.seat_id, seat);
      }

      continue;
    }

    const existing = seatsById.get(seat.seat_id);

    if (existing === undefined) {
      seatsById.set(seat.seat_id, seat);
    } else if (existing?.demand_partner_id !== seat.demand_partner_id) {
      seatsById.set(seat.seat_id, null);
    }
  }

  return seatId => seatsById.get(seatId) ?? undefined;
}
